export default "/_next/static/chunks/fonts/S6u9w4BMUTPHh6UVSwiPGQ-f1405bd8a987c2ea8a67be8c371af61b.woff2";